import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Dispatch, useState } from "react";
import useAuth from "../../../../../../../hooks/useAuth";

const ForgotPassword = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: Dispatch<React.SetStateAction<boolean>>;
}) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState<string | null>(null);

  const { postForgotPassword } = useAuth();

  const handleClose = () => {
    setOpen(false);
    navigate("/home");
  };

  /** Basic email validation */
  const validateEmail = (value: string) => {
    if (!value) {
      setEmailError("Email is required");
      return false;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setEmailError("Please enter a valid email address");
      return false;
    }

    setEmailError(null);
    return true;
  };

  const handleSubmit = () => {
    if (!validateEmail(email)) return;

    postForgotPassword.mutate(
      { email },
      {
        onSuccess: () => {
          handleClose();
        },
      }
    );
  };

  return (
    <Stack>
      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>Forgot your password?</DialogTitle>

        <DialogContent>
          <TextField
            fullWidth
            type="email"
            label="Email address"
            placeholder="Enter your email"
            margin="dense"
            value={email}
            error={Boolean(emailError)}
            helperText={
              emailError ?? "We’ll send you a link to reset your password."
            }
            onChange={(e) => {
              setEmail(e.target.value);
              validateEmail(e.target.value);
            }}
          />
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", gap: 1 }}>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={
              !email || Boolean(emailError) || postForgotPassword.isLoading
            }
          >
            {postForgotPassword.isLoading ? (
              <CircularProgress size={20} />
            ) : (
              "Send reset link"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
};

export default ForgotPassword;
